import { useMemo } from 'react';
import useMultipleQueries from '../../../util/rtk/useQueries';
import { IUser } from '../api/user.model';
import UserAPI from '../api/UserAPI';

// Join many queries into one
// This is a custom hook that uses the `getUser` query from the `UserAPI` to fetch user data based on an array of user IDs.
function useUsers(usersIds?: string[]) {
  const memoizedIds = useMemo(
    () => [...new Set(usersIds ?? [])].sort(),
    [usersIds?.slice().sort().join(',')]
  );

  return useMultipleQueries<any, IUser, string>(
    UserAPI.endpoints.getUser,
    memoizedIds,
    { skip: !memoizedIds.length }
  );
}

export default useUsers;
